import { Utils } from '../Utils.js';
import { Expression } from './Expression.js';
export class PackageDeclaration extends Expression {
    constructor(type, contexts) {
        super();
        this.contexts = contexts;
    }
    accept(visitor) {
        const labelsToExecute = visitor.getLabelsToExecute();
        if (labelsToExecute.length === 0 || this.labels.length === 0) {
            return true;
        }
        const anies = Utils.intersect(this.labels, labelsToExecute);
        return anies.length > 0;
    }
    getContexts() {
        return this.contexts;
    }
    setExecutionLabels(labels) {
        this.labels = labels;
    }
    setRawOclExpression(oclExpression) {
        this.oclExpression = oclExpression;
    }
    getRawOclExpression() {
        return this.oclExpression;
    }
    evaluate(visitor) {
        if (this.accept(visitor)) {
            const contextsToVisit = this.getContexts()
                .filter(ctx => ctx.accept(visitor));
            const evaluationResult = !contextsToVisit
                .map(ctx => ctx.evaluate(visitor))
                .some(inv => inv === false);
            visitor.setEvaluationResult(evaluationResult);
        }
        return this;
    }
}
//# sourceMappingURL=PackageDeclaration.js.map